import React from 'react'
import {
  Avatar,
  Card,
  Col,
  FacilityInformation,
  Row
} from 'react-angle-dashboard-components'
import { useFacilityProfile } from './context'
import { FloatingContainer, ProfileDetail, ProfileHeader } from './style'

export const HeaderSection = () => {
  const { current } = useFacilityProfile()
  return (
    <Row className="py-5">
      <Col xs="12" md="8">
        <ProfileHeader>
          <Avatar
            circle
            centered
            size="xxl"
            fallbackContent={
              <i className="display-3 text-white icon icon-facility"></i>
            }
          />
          <ProfileDetail className="d-flex align-self-center">
            <div className="mb-3 flex-column align-items-start">
              <h3 className="mb-1 text-capitalize">
                {current?.facility_name?.toLocaleLowerCase()}
              </h3>
              {/*        <Badge
                variant={inNetwork ? 'success' : 'warning'}
                className="text-white p-1 fs-16"
              >
                {inNetwork ? messages.inNetwork : messages.outOfNetwork}
              </Badge> */}
              <p className="text-muted text-capitalize">
                {current?.specialties?.toLocaleLowerCase()}
              </p>
            </div>
            {/* <SaveForLaterButton /> */}
          </ProfileDetail>
        </ProfileHeader>
      </Col>
      <Col xs="12" md="4">
        <FloatingContainer>
          <Card>
            <FacilityInformation
              isOpen
              urgentCareHours={[]}
              location={current?.address?.toLocaleLowerCase() || '-'}
            />
          </Card>

          {/* <Card className="mt-3">
            <Card.Body
              style={{
                minHeight: 80
              }}
              className="p-1 pl-2 pt-3 pb-3"
            >
              <Row>
                <Col xs="2">
                  <i
                    style={{
                      fontSize: 35
                    }}
                    className="pt-2 text-primary icon icon-question-mark"
                  ></i>
                </Col>
                <Col>
                  <strong className="mb-1">{messages.seeAProblem}</strong>
                  <p className="text-primary mb-0">{messages.suggest}</p>
                </Col>
              </Row>
            </Card.Body>
          </Card> */}
        </FloatingContainer>
      </Col>
    </Row>
  )
}
